module.exports = "<div class=\"modal-dialog train-route\" uib-modal-transclude></div>";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/modules/booking-module/trainRoute/train-route-popup.html
// module id = cPHA
// module chunks = 1